function buocQuanLyTaiKhoan() {
  return [
    {
      target: "body",
      placement: "center",
      title: "Bước 1 · Tài khoản nhân sự",
      content:
        "Vai trò (admin/ban_giam_doc/ke_toan/nhan_vien/kho) quyết định menu và quyền của từng người — không tự đổi được vai trò của chính mình, để tự bảo vệ khỏi việc lỡ tay khoá quyền admin của chính tài khoản đang đăng nhập.",
    },
    {
      target: "#tour-quan-ly-tai-khoan-tao-moi",
      title: "Bước 2 · Tạo tài khoản",
      content:
        'Nhập Email đăng nhập, Họ tên, chọn Vai trò và đặt Mật khẩu tạm (ít nhất 6 ký tự) — gửi mật khẩu này cho nhân sự qua kênh riêng, vì nó chỉ hiện MỘT LẦN trên màn hình. Sau đó có thể dùng nút "Gửi email đặt lại MK" thay vì tự đọc mật khẩu cho họ.',
      placement: "bottom",
    },
    {
      target: "#tour-quan-ly-tai-khoan-bang",
      title: "Bước 3 · Đổi vai trò / khoá tài khoản",
      content:
        "Ngay trên mỗi dòng có thể đổi vai trò, gửi email đặt lại mật khẩu, hoặc Vô hiệu hoá tài khoản (người đó bị đăng xuất ngay lập tức) / Kích hoạt lại — không cần mở form riêng.",
      placement: "top",
    },
  ];
}

export default buocQuanLyTaiKhoan;
